import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class Testimonials {
  constructor() {
    this.swiperElements = document.querySelectorAll('[data-testimonials]');

    if (this.swiperElements != null && this.swiperElements.length > 0) {
      this.swiperElements.forEach((swiperElement) => {
        // swiper errors if there isn't a min number for looping
        const CAN_LOOP = swiperElement.querySelectorAll('.swiper-slide').length > 3;

        new Swiper(swiperElement, {
          modules: [Navigation, Pagination],
          loop: CAN_LOOP,
          slidesPerView: 1,
          spaceBetween: 32,

          breakpoints: { 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } },

          pagination: {
            el: swiperElement.querySelector('.swiper-pagination'),
            clickable: true,
          },

          navigation: {
            nextEl: swiperElement.parentNode.querySelector('.swiper-button-next'),
            prevEl: swiperElement.parentNode.querySelector('.swiper-button-prev'),
          },
        });
      });
    }
  }
}

export default Testimonials;
